import { formatClearRatePercent } from "./clearRate.js";

const SIZE = 64;
const STROKE = 6;
const RADIUS = (SIZE - STROKE) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
const CENTER = SIZE / 2;

type Props = {
  clearRate: number | null;
  color?: string;
};

export function ClearRateRing({ clearRate, color }: Props) {
  if (clearRate === null) {
    return (
      <svg className="clear-rate-ring" width={SIZE} height={SIZE} role="img" aria-label="挑戦データなし">
        <circle cx={CENTER} cy={CENTER} r={RADIUS} fill="none" stroke="var(--line)" strokeWidth={STROKE} strokeDasharray="3 5" />
        <text x="50%" y="50%" textAnchor="middle" dominantBaseline="central" className="clear-rate-ring-unknown">
          ?
        </text>
      </svg>
    );
  }

  const percent = formatClearRatePercent(clearRate);
  return (
    <svg className="clear-rate-ring" width={SIZE} height={SIZE} role="img" aria-label={`クリア率 ${percent}`}>
      <circle cx={CENTER} cy={CENTER} r={RADIUS} fill="none" stroke="var(--line)" strokeWidth={STROKE} />
      <circle
        cx={CENTER}
        cy={CENTER}
        r={RADIUS}
        fill="none"
        stroke={color}
        strokeWidth={STROKE}
        strokeLinecap="round"
        strokeDasharray={`${(clearRate * CIRCUMFERENCE).toFixed(1)} ${CIRCUMFERENCE.toFixed(1)}`}
        transform={`rotate(-90 ${CENTER} ${CENTER})`}
      />
      <text x="50%" y="46%" textAnchor="middle" dominantBaseline="central" fill={color} className="clear-rate-ring-value">
        {percent}
      </text>
      <text x="50%" y="70%" textAnchor="middle" dominantBaseline="central" className="clear-rate-ring-label">
        クリア率
      </text>
    </svg>
  );
}
